import React from 'react';
import { useTranslation } from 'react-i18next';
import { BadgeCheck, ShieldCheck, Store, UserCheck } from 'lucide-react';

interface StatItemProps {
  value: string;
  label: string;
  icon: React.ReactNode;
}

function StatItem({ value, label, icon }: StatItemProps) {
  return (
    <div className="flex items-center justify-center flex-col sm:flex-row sm:text-left text-center p-4">
      <div className="flex-shrink-0 flex items-center justify-center w-16 h-16 rounded-full bg-[#002549] text-white mb-4 sm:mb-0 sm:mr-4">
        <div className="w-8 h-8 flex items-center justify-center">
          {icon}
        </div>
      </div>
      <div className="min-w-0">
        <div className="text-4xl font-bold text-slate-900 dark:text-white">{value}</div>
        <div className="text-slate-600 dark:text-slate-400 mt-1">{label}</div>
      </div>
    </div>
  );
}

export function StatsBanner() {
  const { t } = useTranslation();
  return (
    <div className="bg-slate-50 dark:bg-slate-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-10">
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white sm:text-3xl">
            {t('statsBanner.title')}
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <StatItem 
            value="20+" 
            label={t('statsBanner.storesProtected')} 
            icon={<Store className="h-8 w-8" />} 
          />
          <StatItem 
            value="91%" 
            label={t('statsBanner.aiAccuracy')} 
            icon={<BadgeCheck className="h-8 w-8" />} 
          />
          <StatItem 
            value="60%" 
            label={t('statsBanner.shrinkageReduction')} 
            icon={<ShieldCheck className="h-8 w-8" />} 
          />
          <StatItem 
            value="500+" 
            label={t('statsBanner.alertsGenerated')} 
            icon={<UserCheck className="h-8 w-8" />} 
          />
        </div>
      </div>
    </div>
  );
}